<template>
  <div class="flow__btn toolbar-icon" :title="$t('title.processFlow')" @click="toggleProcessFlow">
    <i :class="{ 'icon-sitemap': flowEditorVisible, 'icon-sitemap-outline': !flowEditorVisible }"> </i>
  </div>
</template>

<script>
import DesignerMixin from "../DesignerMixin";
export default {
  mixins: [DesignerMixin],
  methods: {
    async toggleProcessFlow(event) {
      const id = "Show_Flow";
      if (this.flowEditorVisible) return this.$store.dispatch("cells/editCellContent", { id, value: "0" });

      return this.$store.dispatch("cells/editCellContent", { id, value: "" });
    },
    callFunc() {
      this.toggleProcessFlow();
    },
  },
};
</script>

<style lang="less" scoped>
@import "../../../assets/styles/variables.less";
.flow__btn {
  color: @kk-color-dark;
}
</style>
